export const filterCategories = ['artistName', 'recommendedKey', 'tags', 'difficulty', 'includedChords'];
export const songSegmentCategories = ['Verse', 'Chorus', 'Bridge', 'Pre-Chorus', 'Refrain', 'Ending'];

// default array for initial values for the first time setting chords-lyrics
export const defaultSongSegmentsArray = [{ type: 'verse', repeated: 'no', chordsLyrics: '' }, { type: 'chorus', repeated: 'no', chordsLyrics: '' }];